
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      
      deleteact: false,
        insertact: false,
        updateact: false,
        viewact: false,
      keywordRolenaerules: [
          v => !!v || ' Role Name is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input hanya boleh berisi huruf, angka, spasi, dan spesial caracter (.@_-)',
        ],
      search: '',
      dialog: false,
      dialogDelete: false,
      keywordRoleName: '',
      maxTopic: '',
      maxKeyword: '',
      keywordRoleStatus: 0,
      itemKeywordRoleStatus: [
        {value: 1, active: 'Enabled'},
        {value: 0, active: 'Disabled'}
      ],
      headers: [
        { text: 'Role Name', value: 'ROLE_NAME' },
        { text: 'Max Topic', value: 'MAX_TOPIC' },
        { text: 'Max Keyword', value: 'MAX_KEYWORD' },
        { text: 'Role Status', value: 'ROLE_STATUS_TEXT' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'SYS_CREATED_BY' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'SYS_UPDATED_BY' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      keywordrole: [],
      id_keywordrole:'',
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Keyword Role' : 'Update Keyword Role'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      getColor(status) {
        return status === 'Disabled' ? 'red' : 'green';
      },
      async initialize () {
        this.tableLoading = true;
        axios.get("keyword-role",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            // this.keywordrole = response.data.role_keyword
            let res = decryptionData(response.data.token);
            this.keywordrole = res.role_keyword
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      editItem (item) {
        // alert(item);
        this.id_keywordrole = item
        this.editedIndex = 1
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "keyword-role-id",
          data: {
            seq_id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            console.log(response.data);
            
            const dat = decryptionData(response.data.token);
            this.id_keywordrole = dat.SEQ_ID;
            this.keywordRoleName = dat.ROLE_NAME
            this.maxTopic = dat.MAX_TOPIC
            this.maxKeyword = dat.MAX_KEYWORD


            this.keywordRoleStatus = dat.ROLE_STATUS
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      deleteItem (item) {   
        // alert(item);
        this.id_keywordrole = item
        this.editedIndex = this.keywordrole.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
        // alert( this.editedItem);
      },
      deleteItemConfirm () {
        this.keywordrole.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "keyword-role/delete",
          data: {
            seq_id: this.id_keywordrole
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      close () {
        this.dialog = false
        this.id_keywordrole = '';
        this.keywordRoleName =''
        this.maxTopic =''
        this.maxKeyword =''
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        // edit 
        if (this.editedIndex == -1) { 
          this.id_keywordrole = '';
        }
        this.keywordrole.push(this.editedItem)
        axios.put("keyword-role/action", 
          {
            seq_id:this.id_keywordrole,
            role_name:this.keywordRoleName,
            max_topic:this.maxTopic,
            max_keyword:this.maxKeyword,
            role_name_lama:this.keywordRoleName,
            role_status:this.keywordRoleStatus,
          },
          {headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          )
        .then((response) => {
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.initialize();
                this.$router.push('/keywordrole');
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
              } 
          })
        .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  e.response.data.msg;
                          this.btnload = false
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
    },
  }